/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';
import { ReactComponent as ButtonClickIcon } from 'assets/icons/product-layout/preview/button-click.svg'
import Commenting from '../products/commenting/commenting';
import ArticleSentiment from '../products/articlesentiment/articlesentiment';
import TrendingNow from '../products/trendingnow/trendingnow';
import ControlBar from '../controlbar/controlbar';
import Placeholder from 'material/placeholder/placeholder';
// styles
import injectSheet from 'react-jss'
import styles from './inline_styles'

const ArticleHeader = (
  <Space direction={'column'}>
    <Space klass={'articleheader'} direction={'column'}>
      <Space justifyContent={'space-between'}>
        <Placeholder width={'40px'} />
        <Space justifyContent={'flex-end'}>
          <Placeholder width={'40px'} />
          <Placeholder width={'40px'} />
          <Placeholder width={'40px'} />
        </Space>
      </Space>
      <h3>Article headline</h3>
      <Space direction={'column'} gap={16}>
        <Space direction={'column'}>
          <Placeholder />
          <Placeholder width={'90%'} />
          <Placeholder width={'80%'} />
        </Space>
        <Space direction={'column'}>
          <Placeholder />
          <Placeholder width={'90%'} />
          <Placeholder width={'80%'} />
          <Placeholder width={'90%'} />
          <Placeholder width={'70%'} />
        </Space>
      </Space>
    </Space>
  </Space>
)
/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW CONTROL BAR ~~~~~~~~~~ ========== */
const Inline = injectSheet(styles)((props) => {

  const { trigger, controlBarPlacement, controlBarAlignment,  products = [], showCommenting, showTrendingNow, showArticleSentiment } = props

  const flexDirection = trigger !== 'CONTROL_BAR' ? 'column' : controlBarPlacement === 'LEFT_EDGE' ? 'row' : controlBarPlacement === 'RIGHT_EDGE' ? 'row-reverse' : 'column-reverse'

  const noProducts = !showCommenting && !showTrendingNow && !showArticleSentiment
  if(noProducts) return null

  return (
    <Space klass={`inline ${props.classes.inline}`} direction={flexDirection}>
      <Space klass={`trigger ${trigger} ${controlBarAlignment}_ALIGNMENT ${controlBarPlacement}_PLACEMENT`} alignItems={trigger !== 'CONTROL_BAR' ? 'center' : 'flex-start'} justifyContent={trigger !== 'CONTROL_BAR' ? 'center' : 'flex-end'}>
        {trigger === 'CONTROL_BAR' && (
           <div>
            <ControlBar 
              alignment={controlBarAlignment} 
              placement={controlBarPlacement} 
              products={products} 
              showCommenting={showCommenting}  
              showTrendingNow={showTrendingNow}
              showArticleSentiment={showArticleSentiment}
              onSelect={() => {}}  
            />
          </div>
        )}
      </Space>
        <Space klass={`inlinecontainer ${trigger}`} justifyContent={'center'} direction={'column'} gap={32}>
        {ArticleHeader}
        {trigger === 'BUTTON' && (
          <Space klass={'trigger'} alignItems={'center'} justifyContent={'center'}>
          {trigger === 'BUTTON' && (
            <div>
              <div className={'button'}>BUTTON</div>
              <ButtonClickIcon className='buttonclickicon' />
            </div>
          )}
        </Space>
        )}
          {products.map(product => (
            <>
              {product === 'COMMENTING_V2' && showCommenting && <Commenting />}
              {product === 'ARTICLE_SENTIMENT_V2' && showArticleSentiment && <ArticleSentiment />}
              {product === 'TRENDING_NOW_V2' && showTrendingNow && <TrendingNow />}
            </>
          ))}
        </Space>
      </Space> 
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Inline;
